<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="large" color="#09c" type="pacman" [fullScreen]="true"></ngx-spinner>

<div *ngIf='loading == true' class="container text-white py-5">
    <div class="row">
        <div class="col-md-4">
            <img class="w-100" [src]="imgBaseUrl+moviesDetails.poster_path" >
        </div>
        <div class="col-md-8">
            <div class="moviesdetails">
                <h1 class="p-3">{{moviesDetails.original_title}}</h1>
                <p class="lead">{{moviesDetails.overview}}</p>
                <h4>Release Date : {{moviesDetails.release_date}}</h4>
            </div>
            <div class=" row">
                <div *ngFor="let data of top4" class=" cardbox  ">
                    <a [routerLink]="['/moviesdetails', data.id]" >
                    <img [src]="imgBaseUrl+data.poster_path" class="card-img-top hightvalue">
                    <div class="card-body">
                      <h5 class="card-title back">{{data.original_title}}</h5>
                    </div>
                    </a>
                </div>
                
            </div>
            <div class="back margintop">
                <a  class="btn btn-outline-danger btn-lg active back" role="button" [routerLink]="['/movies']">Back to Movies</a>
            </div>
        </div>
    </div>
</div>
